/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import LouveIcon from '../icons/Louve';
import Date from './Date';

import styles from '../../../styles/partials/author.module.scss';

const propTypes = {
    author: AppPropTypes.author,
    date: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    author: null,
    date: null,
    className: null,
};

const Author = ({ author, date, className }) => {
    const { name, image } = author || {};
    const { url: imageUrl = null } = image || {};
    return (
        <div
            className={classNames({
                [styles.container]: true,
                [className]: className !== null,
            })}
        >
            <div className={styles.inner}>
                <div className={styles.imageContainer}>
                    {imageUrl !== null ? (
                        <img className={styles.image} src={imageUrl} alt={name} />
                    ) : (
                        <LouveIcon className={styles.defaultAvatar} />
                    )}
                </div>
                <div className={styles.right}>
                    <div className={styles.authorName}>{name}</div>
                    {date !== null ? <Date date={date} withoutTime withoutWeekday /> : null}
                </div>
            </div>
        </div>
    );
};

Author.propTypes = propTypes;
Author.defaultProps = defaultProps;

export default Author;
